export enum LoginEvent {
    Started = "Login_Started",
    Failed = "Login_Failed",
    FailedCollect = "Login_Failed_OnCollect",
    FailedQrCode = "Login_Failed_OnQrCode",
    Logout = "Login_Logout"
}